import React, { useState } from 'react';
import PaymentModal from './PaymentModal';
import CustomButton from '../Button/CustomButton';
import AddIcon from '../CustomSVGIcons/AddIcon';
import { strings } from '../../constants/strings';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { Box, Button } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { IPaymentCard } from '../../types/global/generic.types';

export interface SimpleAddCardModalProps {
    variant?: 'button' | 'link';
    onCardReady?: (card: IPaymentCard) => void;
    title?: string;
}

const SimpleAddCardModal: React.FC<SimpleAddCardModalProps> = ({
    variant = 'button',
    onCardReady,
    title = 'Payment method',
}) => {
    const [open, setOpen] = useState(false);
    const { themeStyle } = useThemeContext();
    const t = theme[themeStyle];

    const modal = <PaymentModal open={open} onClose={() => setOpen(false)} onCardReady={onCardReady} title={title} />;

    if (variant === 'link') {
        return (
            <Box>
                {modal}
                <Button
                    onClick={() => setOpen(true)}
                    startIcon={<AddIcon height="18px" width="18px" fill={t.highlight} />}
                    sx={{
                        textTransform: 'none',
                        fontFamily: FONT_ENUM.MAIN_BOLD,
                        fontSize: 13,
                        color: t.highlight,
                        minWidth: 0,
                        p: 0,
                        '&:hover': { bgcolor: 'transparent', opacity: 0.85 },
                    }}>
                    Add new card
                </Button>
            </Box>
        );
    }

    return (
        <Box mt={2}>
            {modal}
            <CustomButton
                label={strings.add_new_card}
                onClick={() => setOpen(true)}
                withIcon
                buttonProps={{ variant: 'text' }}
                textStyle={{ color: t.highlight }}
                textSx={{ color: t.highlight }}
                sx={{
                    backgroundColor: 'transparent',
                    color: t.highlight,
                    border: 'none',
                    boxShadow: 'none',
                    minWidth: 0,
                    px: 0,
                    justifyContent: 'flex-start',
                    '&:hover': {
                        backgroundColor: alpha(t.highlight, 0.08),
                        color: t.highlight,
                        WebkitTextFillColor: t.highlight,
                        border: 'none',
                        boxShadow: 'none',
                    },
                }}
                customIcon={<AddIcon style={{ marginLeft: '4px' }} height={'20px'} width={'20px'} fill={t.highlight} />}
            />
        </Box>
    );
};

export { SimpleAddCardModal };
